import { Socket } from 'socket.io-client';
import { SocketMessage } from '@utils/gameSockets';
import { AppDispatch } from '@app/store';
import { mainApi } from '@app/store/api/emptyApi';

interface BalanceOnResultMessage extends SocketMessage {
  data: { balance: string };
}

export const balanceOnMessage = (dispatch: AppDispatch, socket: Socket) => {
  socket.on('balance/update', (response: BalanceOnResultMessage) => {
    dispatch(
      mainApi.util.updateQueryData(
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        'authControllerWhoami',
        undefined,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (old: any) => {
          old.balance = response.data.balance;
        },
      ),
    );
  });
};
